/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload two photos and turn them into the viral Hotel Lobby AI duet video. Orange booth, one mic, vertical 9:16 MP4 with audio. Choose a plan and get your result in minutes.`)
};

const zh_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用两张已获授权的照片探索 Hotel Lobby AI Filter：预览暖橙色录音棚中的双人对唱，构思互动细节，再将提示词带到 AI 视频工作室生成作品。`)
};

/**
* | output |
* | --- |
* | "Upload two photos and turn them into the viral Hotel Lobby AI duet video. Orange booth, one mic, vertical 9:16 MP4 with audio. Choose a plan and get your res..." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_description(inputs)
	return zh_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }